export default __webpack_public_path__ + "static/media/logo.f81ae92b.svg";